<template>
  <div class="pa-3 ma-3">
    <v-alert-dialog ref="alert"></v-alert-dialog>

    <!-- Crear/Editar -->
    <v-dialog max-width="65%" v-model="dialogAddEdit" persistent>
      <v-card>
        <v-card-title>
          {{ editedItem.id_resguardo_tipo === null ? "Crear" : "Editar" }} Tipo de Resguardo
        </v-card-title>

        <v-card-text>
          <v-row>
            <v-col cols="12">
              <v-text-field
                v-model="editedItem.nombre"
                label="Nombre"
                outlined
                dense
                hide-details
              />
            </v-col>
          </v-row>
        </v-card-text>

        <v-card-actions>
          <v-spacer />
          <v-btn text color="green" @click="closeDialogAddEdit">Cancelar</v-btn>
          <v-btn text color="red" :loading="loadingSave" @click="saveDialogAddEdit">Guardar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Eliminar -->
    <v-dialog max-width="65%" v-model="dialogDelete" persistent>
      <v-card>
        <v-card-title>Eliminar Tipo de Resguardo</v-card-title>
        <v-card-text>
          ¿Está seguro de que desea eliminar el tipo de resguardo
          llamado "<b>{{ editedItem.nombre }}</b>"? Esta acción es permanente.
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn text color="green" @click="closeDialogDelete">Cancelar</v-btn>
          <v-btn text color="red" :loading="loadingDelete" @click="saveDialogDelete">Eliminar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Botón Crear -->
    <v-row>
      <v-col cols="12">
        <v-btn color="primary" @click="openDialogAddEdit(null)">
          Crear Tipo de Resguardo
        </v-btn>
      </v-col>
    </v-row>

    <!-- Tabla -->
    <v-row>
      <v-col cols="12">
        <v-data-table :items="items" :headers="headers" :loading="loading">
          <template v-slot:[`item.actions`]="{ item }">
            <v-icon v-if="item.editable" small class="mr-2" @click="openDialogAddEdit(item)">mdi-pencil</v-icon>
            <v-icon v-if="item.editable" small class="mr-2" @click="openDialogDelete(item)">mdi-delete</v-icon>
            <v-icon @click="openDialogSubtipo(item)">mdi-format-list-bulleted</v-icon>
          </template>
        </v-data-table>
      </v-col>
    </v-row>

    <v-dialog v-model="dialogSubtipo" max-width="80%" persistent>
      <v-card>
        <v-card-title>
          Subtipos de {{ editedItem.nombre }}
        </v-card-title>

        <v-card-text>
          <ResguardoSubTipo
            v-if="dialogSubtipo"
            :idResguardoTipo="editedItem.id_resguardo_tipo"
            :tipoNombre="editedItem.nombre"
          />
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="green"
            text
            @click="closeDialogSubtipo"
          >
            Cerrar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import axios from "axios";
import VAlertDialog from "@/components/VAlertDialog.vue";
import ResguardoSubTipo from './ResguardoSubTipo.vue';

export default {
  components: { 
    VAlertDialog,
    ResguardoSubTipo
  },
  data: () => ({
    dialogAddEdit: false,
    dialogDelete: false,
    dialogSubtipo: false,

    loading: false,
    loadingSave: false,
    loadingDelete: false,

    items: [],
    headers: [
      {
        text: "Nombre",
        value: "nombre",
        align: "center",
        width: "70%"
      },
      {
        text: "Acciones",
        value: "actions",
        align: "center",
        width: "15%"
      }
    ],

    editedItem: {
      id_resguardo_tipo: null,
      nombre: "",
      editable: true
    },

    defaultEditedItem: {
      id_resguardo_tipo: null,
      nombre: "",
      editable: true
    }
  }),

  mounted() {
    this.getItems();
  },

  methods: {
    // ==================================
    //            GET LIST
    // ==================================
    getItems() {
      this.loading = true;
      axios
        .get("/RACatalogos/ListarResguardoTipos")
        .then((res) => (this.items = res.data))
        .catch((err) => console.log(err))
        .finally(() => (this.loading = false));
    },

    // ==================================
    //        DIALOG ADD/EDIT
    // ==================================
    openDialogAddEdit(editItem = null) {
      if (editItem != null)
        this.editedItem = Object.assign({}, editItem);
      else
        this.editedItem = Object.assign({}, this.defaultEditedItem);

      this.dialogAddEdit = true;
    },

    closeDialogAddEdit() {
      this.editedItem = Object.assign({}, this.defaultEditedItem);
      this.dialogAddEdit = false;
    },

    saveDialogAddEdit() {
      if (!this.editedItem.nombre || this.editedItem.nombre.length === 0) {
        this.$refs.alert.setMessage("", "Debe ingresar un nombre válido.");
        this.$refs.alert.open();
        return;
      }

      if (this.editedItem.nombre.length > 512) {
        this.$refs.alert.setMessage("", "El nombre no puede exceder 512 caracteres.");
        this.$refs.alert.open();
        return;
      }

      this.loadingSave = true;

      axios({
        method: this.editedItem.id_resguardo_tipo === null ? "POST" : "PUT",
        url:
          this.editedItem.id_resguardo_tipo === null
            ? "/RACatalogos/CrearResguardoTipo"
            : `/RACatalogos/EditarResguardoTipo/${this.editedItem.id_resguardo_tipo}`,
        data: {
          nombre: this.editedItem.nombre
        }
      })
        .then(() => {
          this.getItems();
          this.closeDialogAddEdit();
        })
        .catch((err) => {
          if (err.response && err.response.status === 409) {
            this.$refs.alert.setMessage("", "Ya existe un Tipo de Resguardo con este nombre.");
            this.$refs.alert.open();
          }
        })
        .finally(() => (this.loadingSave = false));
    },

    // ==================================
    //           DELETE
    // ==================================
    openDialogDelete(item) {
      this.editedItem = Object.assign({}, item);
      this.dialogDelete = true;
    },

    closeDialogDelete() {
      this.editedItem = Object.assign({}, this.defaultEditedItem);
      this.dialogDelete = false;
    },

    saveDialogDelete() {
      this.loadingDelete = true;

      axios
        .delete(`/RACatalogos/EliminarResguardoTipo/${this.editedItem.id_resguardo_tipo}`)
        .then(() => {
          this.closeDialogDelete();
          this.getItems();
        })
        .catch((err) => console.log(err))
        .finally(() => (this.loadingDelete = false));
    },
    openDialogSubtipo(item){
      this.dialogSubtipo = true;
      this.editedItem = Object.assign({}, item);
    },
    closeDialogSubtipo(){
      this.dialogSubtipo = false;
      this.editedItem = Object.assign({}, this.defaultEditedItem);
    }
  }
};
</script>
